const html = require("./html/productView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AdditionalServicesView from "./AdditionalServicesView";
import DomainStore from "../../../stores/CmrDomainStore";
import ServiceStore from "../../../stores/CmrServiceStore";
import MandatoryServiceProcessor from "../businessLogic/MandatoryServiceProcessor";
const elementsMap = {
  additionalServicesEntryPoint: ".additional-services-entry-point",
  productSku: ".product-main-sku",
  productDesc: ".product-desc",
  prepItemFragile: ".prep-item-fragile",
  prepItemBarcode: ".prep-item-barcode",
  noPrepNeeded: ".prep-item-no-prep",
  productQuantity: ".product-agg-quantity",
  servicesSelect: ".additional-services-select"
}

export default function Product(asnDetails, {readOnly}={}){
  const asnDetailIds = _(asnDetails).pluck("id");
  const self = this;
  self._element = $();
  const els = {};
  let additionalServicesView;
  self.init = function(){
    render();
  }
  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }
  self.getElement = function(){
    return self._element;
  }
  function setWidgets(){
    if(!readOnly){
      els.servicesSelect.select2({
        placeholder: 'Select an option',
        data: getServiceSelectDataArray()
      });
    }
  }
  function update(){
    // console.log("updating product view");
    // optimization for reuse implementation,
    // when read only, obviously we don't need,
    // to mutate state/rerender views,
    // this is handled by the non-read only configuration
    if(!readOnly){
      const mandatoryServiceProcessor = new MandatoryServiceProcessor(getAsnDetailIds());
      mandatoryServiceProcessor.forceAddMandatoryServices();
      mandatoryServiceProcessor.forceRemoveUnneededMandatoryServices();
    }
    if(getFirstAsnDetail()) {
      updateValues();
      updatePrep();
    }
    additionalServicesView = renderAdditionalServicesView();
    els.additionalServicesEntryPoint.html(extractElements([additionalServicesView]));
  }
  function updatePrep(){
    // example item sku for fragile: "23432"
    handleDisplayFor(els.prepItemFragile, isFragile());
    // example item sku for fragile: "unknown"
    handleDisplayFor(els.prepItemBarcode, needsBarcode());
    handleDisplayFor(els.noPrepNeeded, (!isFragile() && !needsBarcode()));
  }
  function bindStores(){
    // AsnDetailStore.bindListenersForSubsetOfDataViaIds(asnDetailIds, "asn_details:change", update);
    ServiceStore.bindListener("cmr_services:add", update);
    ServiceStore.bindListener("cmr_services:remove", update);
    ServiceStore.bindListener("cmr_services:change", update);
  }
  self.unbindListeners = function(){
    ServiceStore.unbindListener("cmr_services:add", update);
    ServiceStore.unbindListener("cmr_services:remove", update);
    ServiceStore.unbindListener("cmr_services:change", update);
  }
  function bindElements(){
    els.servicesSelect.on("change", onAddServiceChanged);
  }
  function onAddServiceChanged(){
    onAddService({domainId: els.servicesSelect.val()});
  }
  function updateValues(){
    const asnDetail = getFirstAsnDetail();
    els.productSku.text(asnDetail.sku);
    els.productDesc.text(`(${getProductItem().prdDescription || "no description"})`);
    els.productQuantity.text(calcProductsQuantity());
  }
  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindElements();
    bindStores();
  }
  function renderAdditionalServicesView(){
    const additionalServicesView = new AdditionalServicesView(getFirstAsnDetail(),
      {
        readOnly,
        getDomains,
        getServices: getDeduppedServices,
        onAddService,
        getAggregateCurrencyTotalViaCurrencyPerUnits,
        shouldShowServiceCloseBtn,
        onRemoveServiceRow
      }
    );
    additionalServicesView.init();
    return additionalServicesView;
  }
  function onRemoveServiceRow(serviceId){
    // console.log(`removing: ${serviceId}`);
    ServiceStore.removeServicesByIds([serviceId]);
  }
  function onAddService({domainId}){
    ServiceStore.createOrUpdateServicesForAsnDetailIds(getAsnDetailIds(), {
      cdm_id: domainId
    });
  }
  function shouldShowServiceCloseBtn({domain}){
    return !isMandatoryDomain(domain);
  }
  function getDomains(){
    return DomainStore.getOnlyProductServiceLevels();
  }
  function getServices(){
    return ServiceStore.getServicesViaAsnDetailIds(getAsnDetailIds());
  }
  function getDeduppedServices(){
    // NOTE:
    // all asn details within this bundle
    // should have the same sku at the point
    // and we only care about services on a
    // per sku basis VISUALLY, so just use first one
    return ServiceStore.getServicesViaAsnDetailIds([getAsnDetailIds()[0]]);
  }
  function isFragile(){
    return ProductItemStore.isFragile(getProductItem());
  }
  function needsBarcode(){
    return ProductItemStore.needsBarcode(getProductItem());
  }
  function getAggregateCurrencyTotalViaCurrencyPerUnits(numb){
    return calcProductsQuantity() * numb;
  }
  function calcProductsQuantity(){
    let total = 0;
    _(getAsnDetails()).map((detail)=>{
      total += AsnDetailStore.calcTotalQuantityFor(detail);
    });
    return total;
  }
  function isMandatoryDomain(domain){
    // check if service is pointing to ANY manditory domain
    return DomainStore.isMandatoryDomain(domain);
  }
  // function forceAddMandatoryServices(){
  //   forceAddMandatoryServicesViaAsnDetailIds(getAsnDetailIds());
  // }
  // function forceRemoveUnneededMandatoryServices(){
  //   forceRemoveUnneededMandatoryServicesViaAsnDetailIds(getAsnDetails());
  // }
  function getProductItem(){
    return ProductItemStore.getDataViaAsnDetail(getFirstAsnDetail())[0] || {};
  }
  function getAsnDetailIds(){
    return asnDetailIds;
  }
  function getAsnDetails(){
    return AsnDetailStore.getAsnDetails(asnDetailIds);
  }
  function getServiceSelectDataArray(){
    return _(getDomains()).map((domain)=>{
      return {id: domain.id.toString(), text: domainToSelectOptionText(domain)};
    });
  }
  function domainToSelectOptionText(domain){
    return `${domain.cdm_meaning} (${CmrDomainStore.currencyToHtml(domain)})`;
  }
  function getFirstAsnDetail(){
    return getAsnDetails()[0];
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ProductView.js